import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Resolve an image/video source: full URLs pass through, storage paths route via /api/files
export const mediaUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("blob:") || src.startsWith("data:")) return src;
  const clean = src.replace(/^\/?api\/files\//, "").replace(/^\//, "");
  return `${API}/files/${clean}`;
};

export const formatPrice = (n) =>
  `Fr. ${Number(n).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
